<template>
<div id="app">
  <div class="banner"><img src="./img/banner.png" alt=""></div>
  <div class="aboutus">
    <el-tabs tab-position="left" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="关于我们" name="about">
        <div class="aboutbox about-us-pc">
          <!-- 顶部横幅 -->
          <div class="au-banner">
            <img src="./img/1.jpg" alt="大救星全球综合救援智能云平台">
          </div>

          <!-- 公司简介 -->
          <section class="au-section">
            <div class="au-section__title"><h2>江泰救援服务有限公司简介</h2></div>
            <div class="au-section__body">
              <p class="au-text">
                2016年3月，江泰救援服务有限公司（以下简称江泰救援）在原国家旅游局的指导和推动下成立，总部设在北京（注册资金5000万元）。江泰救援是国内唯一一家自建全球合作服务网络的中资救援公司，并在原国家旅游局的授权下成立“中国公民全球救援指挥中心”。2019年8月，外交部致电驻外使领馆，将江泰救援纳入“海外救援医疗资源清单”，供我驻外使领馆在领事保护工作中联系使用。
              </p>
              <div class="au-honor-list">
                <div class="au-honor-item">自建全球合作服务网络的中资救援公司</div>
                <div class="au-honor-item">原国家旅游局授权成立“中国公民全球救援指挥中心”</div>
                <div class="au-honor-item">2019年外交部纳入“海外救援医疗资源清单”</div>
              </div>
            </div>
          </section>

          <!-- 组织架构 -->
          <section class="au-section">
            <div class="au-section__title"><h2>江泰救援组织架构</h2></div>
            <div class="au-section__body">
              <p class="au-text">
                公司秉承“有求必救”的理念，围绕着出行及生产生活等场景，提供“救援、救治、救助、救护”全方位的全球综合救援服务。先进独有的“大救星”全球综合救援智能云平台，将救援服务、安全保障与高科技融为一体，为客户提供全天候一键式服务。经过近十年的稳定运转及服务实践，得到了合作伙伴与客户的高度赞誉。
              </p>
              <p class="au-text">
                “大救星”全球综合救援智能云平台是江泰救援研发并运营的全球综合服务平台。在大救星平台上，有触手可及的双语星使在线，有近在咫尺的专业机构待命，有保险保障支持的救援服务，有从救援、救治、救护及救助的全需求满足，拥有覆盖出行、生产生活等场景的全球救援、健康监测、全球医疗、安全防护等综合保障能力。
              </p>
              <div class="au-org-img" @click="previewOrgStructure">
                <img :src="orgStructureImg" alt="江泰救援组织架构">
                <span class="au-org-tip">点击查看大图</span>
              </div>
            </div>
          </section>

          <!-- 一、大救星平台 -->
          <section class="au-section">
            <div class="au-section__title"><h2>一、大救星全球综合救援智能云平台</h2></div>
            <div class="au-section__body">
              <p class="au-text">
                大救星平台基于移动互联网技术，通过整合境内外优质资源，以线上线下相结合的方式，用共享经济模式为出境的中国公民、入境的外国友人、境内国民提供及时、高效的全球综合服务。
              </p>
              <p class="au-text">
                作为创新的智能化救援服务平台，大救星拥有针对B端用户的PC系统、针对C端用户的APP和小程序、操作便捷的机构版APP等工具。依靠多端协同，实现了关键节点流转及数据实时回传。此外，平台还实现了各角色间的职能互动，使操作可视化、数据透明化，打造更加高效、便捷的救援服务体验。
              </p>
            </div>
          </section>

          <!-- 二、全球服务网络 -->
          <section class="au-section">
            <div class="au-section__title"><h2>二、全球服务网络</h2></div>
            <div class="au-section__body">
              <div class="au-stats-panel">
                <div class="au-stats-grid">
                  <div class="au-stat-card" v-for="item in networkStats" :key="item.label">
                    <div class="au-stat-number">{{ item.number }}</div>
                    <div class="au-stat-label">{{ item.label }}</div>
                  </div>
                </div>
              </div>
              <p class="au-text au-text--mt">
                江泰救援目前在北京、海南、贵州、江苏、甘肃、云南设有分支机构，在北京、香港设有子公司，在亚洲、非洲、美洲、欧洲、大洋洲设有9家海外代表处。在境外拥有2340名常驻当地懂当地语言又熟悉中文的华人代表（即大救星星使），覆盖全球137个国家和地区、820个城市；境内拥有944名熟悉外语的大救星星使。
              </p>
              <p class="au-text">
                江泰救援一直致力于全球网络资源的发展，资源考察足迹遍布全球200多个国家和地区。在我国驻各地使领馆和领保中心支持下，筛选签约符合平台质量要求的境外救援机构、律师事务所、会计师事务所、安保公司、旅行社、殡仪机构、包机公司、翻译公司等境外服务商1200多家，服务网点超60万个，将医疗救援、商旅助手、健康管理、健康监测、社区服务覆盖到全球。
              </p>
              <p class="au-text">
                健康管理服务网络主要包含医疗机构网络、医生网络、护士网络、康复机构网络、购药送药网络等。服务场景从日常诊疗到诊前、诊中、院中、院后全覆盖，包含医疗费用担保/垫付、基础绿通、儿童绿通、重疾绿通、院后照护、健康体检、报告解读、眼科/齿科、慢病管理、医疗咨询、诊后营养康复指导等服务。绿通服务覆盖全国1000余家三甲医院，合作国内重点心、脑、癌专科名院，10000余家直付/垫付医院，可覆盖全国310多个城市。
              </p>
              <p class="au-text">
                社区服务涵盖日常生活所需的各类服务，包含保洁、管道疏通、开锁、家电清洗及维修等服务，服务覆盖全国31个省（自治区、直辖市）的332个城市、2616个区县。
              </p>
            </div>
          </section>

          <!-- 三、主要服务内容 -->
          <section class="au-section">
            <div class="au-section__title"><h2>三、主要服务内容</h2></div>
            <div class="au-section__body">
              <div class="au-service-grid">
                <div class="au-service-item" v-for="item in serviceList" :key="item.title">
                  <div class="au-service-title">{{ item.title }}</div>
                  <div class="au-service-desc">{{ item.desc }}</div>
                </div>
              </div>
            </div>
          </section>

          <!-- 四、服务优势 -->
          <section class="au-section">
            <div class="au-section__title"><h2>四、我们的服务优势</h2></div>
            <div class="au-section__body">
              <p class="au-text">
                区别于传统救援公司，在大救星平台中，通过星使、专业合作机构、专属救援保险产品的有机结合，可实现六大优势：
              </p>
              <div class="au-advantage-grid">
                <div class="au-advantage-item" v-for="item in advantageList" :key="item.title">
                  <div class="au-advantage-icon">{{ item.icon }}</div>
                  <div class="au-advantage-content">
                    <div class="au-advantage-title">{{ item.title }}</div>
                    <div class="au-advantage-desc">{{ item.desc }}</div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- 五、定位及发展方向 -->
          <section class="au-section">
            <div class="au-section__title"><h2>五、定位及发展方向</h2></div>
            <div class="au-section__body">
              <div class="au-service-grid">
                <div class="au-service-item" v-for="item in directionList" :key="item.title">
                  <div class="au-service-title">{{ item.title }}</div>
                  <div class="au-service-desc">{{ item.desc }}</div>
                </div>
              </div>
              <p class="au-text au-text--mt">
                大救星平台是政府救援的重要补充，是商业救援的创新模式，围绕着出行和生活场景构建了中国公民/海外公民、境内外救援救助机构、健康管理机构以及个体服务者“星使”及医疗人员之间的服务生态圈。目前，江泰救援独有的星使网络已为个人客户现场服务近5000个小时；连续十年为国内2.3万余家旅行社提供全球服务保障，服务累计覆盖超过2亿人次；并与国家签证平台合作，为通过全球95家境外中国签证申请服务中心来华的外籍游客提供救援服务保障。客户还包括中国化学工程集团、中交建工程集团等大型境外劳务企业，中国工商银行、中国农业银行等大型商业银行，中国平安财产股份保险公司、中国平安人寿股份保险公司、中国平安健康股份保险公司、中国太平洋财产股份有限公司、中国人寿财险保险公司、阳光财产保险公司等30多家保险公司，贵州黄果树瀑布、贵州万峰林、贵州千户苗寨、河北东太行、甘肃万象洞、甘肃马蹄寺、山西云丘山等大型旅游景区集团。
              </p>
            </div>
          </section>

        </div>

        <!-- 组织架构大图预览 -->
        <el-dialog
          :visible.sync="orgPreviewVisible"
          title="江泰救援组织架构"
          width="80%"
          top="5vh"
          append-to-body
          custom-class="au-org-dialog"
        >
          <img :src="orgStructureImg" alt="江泰救援组织架构" class="au-org-dialog__img">
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="新闻中心" name="news">
        <div class="newsbox">
          <h2>新闻中心</h2>
          <div v-if="!detail">
            <dl @click="goNewsDetail(item)" v-for="(item,index) in newsList" :key="index">
              <dt><img :src="item.pic?item.pic:require('./img/default.jpg')" alt=""></dt>
              <dd>
                <h6><span>{{item.title}}</span>
                  <!-- <i>{{format(item.updateAt)}}</i> -->
                  <i>{{item.createAt}}</i>
                </h6>
                <p>{{item.dissect}}</p>
                <!-- <span></span> -->
              </dd>
            </dl>
            <el-pagination
              background
              layout="total, prev, pager, next"
              @current-change="handleCurrentChangeNews"
              @prev-click="newsPrev"
              :page-size="10"
              :total="newspageTotal">
            </el-pagination>
          </div>
          <Aboutdetail v-else :id='id'></Aboutdetail>
        </div>
      </el-tab-pane>
      <el-tab-pane label="江泰全球救援联盟">
        <div class="jylmbox">
          <h4>江泰全球救援联盟是江泰救援服务有限公司于2016年3月20日发起创立的，由来自世界各地的独立救援公司、包机公司、安保公司、律师事务所、旅行社、医疗机构、相关中介服务机构等自愿参与并组成的全球性救援服务组织。旨在拓展全球救援行业体系，为联盟成员之间合作共享搭建桥梁。联盟目前已拥有超过200家成员机构，所构建的救援服务网络覆盖全球，含战乱及受经济制裁的国家和地区。</h4>
          <h3>秉持“共享和共赢”宗旨，联盟通过共享经济模式，为每一个成员提供如下便利和利益：</h3>
          <ol>
            <li><img src="./img/1_list.png" alt="">融入到中国大发展的洪流中，分享中国发展的红利。</li>
            <li><img src="./img/2_list.png" alt="">为中国公民、中国企业在当地提供商业化救援服务，获得增收新商机。</li>
            <li><img src="./img/3_list.png" alt="">扩大服务范围以及覆盖国家和地区，提高自身竞争力，吸引更多客户。</li>
            <li><img src="./img/4_list.png" alt="">形成发展平台，救援联盟成员之间互相委托创造更多利益。</li>
            <li><img src="./img/5_list.png" alt="">联盟成员通过举行会议等形式实现信息共享，资源共享。</li>
          </ol>
          <button @click="submitAiderDialog=true">立即加入全球救援</button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="星使服务">
        <div class="xingshibox">
          <h2>星使服务</h2>
          <h4>星使服务是由江泰救援自研自建的本地服务，我们拥有完整的服务模式和星使培训体系，截至目前已经有近三千多名熟悉本地服务的星使分布在全球各地，为国人提供当地救援、救助、陪同、向导、翻译、法律援助、住院安排、医疗就诊、转运等线上线下服务。依托于江泰救援平台，星使可以自行设定服务项目，自动接收来自国人的有酬求助、陪同邀请等。服务亿万国人的同时，还能赚取一笔收益，快来加入星使团队吧。</h4>
          <h2>如何成为星使？</h2>
          <p v-if="false"><img src="./img/ticon.png" alt="">下载大救星</p>
          <p  v-if="false" style="font-weight:normal;margin-left: 1.302083vw">Android手机：国内手机从各大应用市场如360手机助手等应用下载，国外手机从Googleplay下载<br>
苹果手机：从AppStore下载；</p>
          <p><img src="./img/ticon.png" alt="">要成为星使，需要进行以下4步操作</p>
          <img src="./img/iPhone.png" alt="" style="margin-top: 1.5625vw;width: 100%">
        </div>
      </el-tab-pane>
      <el-tab-pane label="服务案例" name="case">
        <div class="newsbox">
          <h2>服务案例</h2>
          <div v-if="!isCaseDetail">
            <dl  @click="goCaseDetail(item)" v-for="(item,index) in caseList" :key="index">
              <dt><img :src="item.pic?item.pic:require('./img/default.jpg')" alt=""></dt>
              <dd>
                <h6><span>{{item.title}}</span>
                  <!-- <i>{{format(item.updateAt)}}</i> -->
                  <i>{{item.createAt}}</i>
                </h6>
                <p>{{item.dissect}}</p>
              </dd>
            </dl>
            <div style="margin: 0 auto"> 
              <el-pagination
            background
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="10"
            :total="pageTotal">
          </el-pagination>
            </div>
          
          </div>
          <Aboutdetail v-else :id='id'></Aboutdetail>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
  <el-dialog :visible.sync="submitAiderDialog" class="modal">
    
      <h2>服务商加盟</h2>
      <form>
        <label for="name">
            <span>
                <small>公司名称:</small>
                <small>Company name</small>
            </span>
            <input type="text" name="" id="name" placeholder="请输入公司名称">
        </label>
        <label for="type">
            <span>
                <small>服务类型:</small>
                <small>Service type</small>
            </span>
            <input type="text" name="" id="type" placeholder="请输入公司服务类型">
        </label>
        <label for="Country">
            <span>
                <small>国家:</small>
                <small>Country</small>
            </span>
            <input type="text" name="" id="Country" placeholder="请输入公司所服务的国家">
        </label>
        <label for="Contact">
            <span>
                <small>联系人姓名:</small>
                <small>Contact name</small>
            </span>
            <input type="text" name="" id="Contact" placeholder="请输入公司联系人">
        </label>
        <label for="Tel">
            <span>
                <small>电话:</small>
                <small>Tel</small>
            </span>
            <input type="text" name="" id="Tel" placeholder="请输入联系人电话">
        </label>
        <label for="Email">
            <span>
                <small>邮箱:</small>
                <small>Company name</small>
            </span>
            <input type="text" name="" id="Email" placeholder="请输入公司邮箱">
        </label>
        <label for="Message">
            <span>
                <small>信息:</small>
                <small>Message</small>
            </span>
            <input type="text" name="" id="Message" placeholder="请输入详细信息">
        </label>
      </form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitAiderDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAiderDialog = false;submit()">确 定</el-button>
      </div>
  </el-dialog>
</div>
</template>

<script>
import util from '@/util/util.js'
import Axios from 'axios'
import Aboutdetail from '@/views/aboutus/aboutdetail'
import orgStructureImg from './img/org-structure.png'

export default {
  components:{
    Aboutdetail
  },
  data () {
    return {
        newsList: '',
        caseList: '',
        detail:false,
        isCaseDetail: false,
        id:'',
        activeName: 'about',
        submitAiderDialog: false,
        api: util.config.api,
        start: '',
        // currentPage: '1',
        count: '10',
        // pageSize: '10',
        pageTotal: null,
        newspageTotal: null,
        /** 组织架构图 */
        orgStructureImg,
        /** 组织架构大图预览 */
        orgPreviewVisible: false,
        /** 全球服务网络数据 */
        networkStats: [
          { number: '1200+', label: '境外服务商' },
          { number: '60万+', label: '服务网点' },
          { number: '3284', label: '境内外双语星使' },
          { number: '9家', label: '海外代表处' },
          { number: '137', label: '覆盖国家和地区' },
          { number: '820', label: '覆盖城市' }
        ],
        /** 主要服务内容 */
        serviceList: [
          {
            title: '（一）大救星APP服务',
            desc: '快速查询境内外外交机构、领事保护机构、警察局、医院、药店位置，快速发起一键救援及一键报案功能。'
          },
          {
            title: '（二）全球救援服务',
            desc: '大救星持续服务30多家知名保险公司、商业银行等金融机构，为2.3万家旅行社及近20家大型央、国企提供“四救十六助”全球综合救援服务，每年服务覆盖人群5000多万，双语星使累计提供服务1000余小时。'
          },
          {
            title: '（三）救援服务清单',
            desc: '大救星首创“救援+保险”的救援服务清单产品。以救援服务清单为载体协助景区、滑雪场、旅行社等流量密集型场景构建“防、保、救、调、赔”五位一体的旅游安全应急救援保障体系。借助市场化手段帮助客户解决落实保障体系建设的资金及技术方案等。目前大救星已为国内300多家景区、滑雪场、旅行社提供服务。'
          },
          {
            title: '（四）健康监测服务',
            desc: '大救星致力于通过救援服务前置降低因突发疾病造成的个人健康危害或意外事故发生几率。通过自主研发设计“大救星健康版”APP及健康监测设备，为客户提供365天*24小时的心率、心电、血氧、血压、体温等指标实时健康监测服务，通过主动提醒、健康风险预警、一键报案、语音互动等提供高效、便捷的健康预警服务，同时将健康监测、健康预警以及发生事故后的救援救助有效衔接，提供全流程的应急救援服务。大救星已为重型货车司机、金融高端客户等群体提供健康监测服务。'
          },
          {
            title: '（五）全球医疗服务',
            desc: '大救星通过整合全球先进、优质的医疗资源，形成完善的全球医疗服务网络，为客户提供全球找药、特药安排等服务；通过“旅游+医疗”模式设计出高性价比且配套安全保障服务的全球医疗产品，为客户提供全球先进医疗就诊预约、手术预约、行程安排等全流程服务。已为客户提供包括赴韩医美、赴日体检、泰国辅助生育、美国肿瘤治疗、特药/靶向药等多项产品和服务。'
          },
          {
            title: '（六）商旅助手',
            desc: '律师推介、安保服务、紧急撤离服务、危机公关处理、保释协调、应急现金协助、行程安排、酒店机票安排等。'
          },
          {
            title: '（七）社区服务',
            desc: '大救星平台提供保洁、管道疏通、开锁、家电清洗、家电维修、甲醛检测、甲醛治理等服务，已成为目前国内最大的社区服务供应平台。'
          }
        ],
        /** 服务优势 */
        advantageList: [
          {
            icon: '📱',
            title: '（一）移动互联网平台式救援',
            desc: '通过大救星APP或微信小程序实现一键救援，实时定位，精准服务。'
          },
          {
            icon: '⚡',
            title: '（二）快速响应、服务满意度100%',
            desc: '全年365天7x24小时中英双语服务，10秒内接听电话、15分钟内协调服务、全流程实时反馈服务进度。专业、高效、贴心处理客户的每一次服务需求，满意度近100%。'
          },
          {
            icon: '🌟',
            title: '（三）全球独有的星使现场服务',
            desc: '依托大救星平台，用户可随时随地发起服务需求，星使提供现场陪同、陪护、翻译、代办等现场服务。'
          },
          {
            icon: '🌐',
            title: '（四）综合服务资源及能力',
            desc: '从单一医疗救援服务商，扩展到包括境内外健康管理机构、医疗团队、当地律所、旅行社、安保公司、翻译公司等综合性服务商，实现救援、救治、救护、救助的一站式全方位综合服务。'
          },
          {
            icon: '🏥',
            title: '（五）健康管理服务全场景渗透',
            desc: '可为客户提供日常诊疗咨询、诊前、诊中、院中、院后全流程及一站式服务，并支持保险产品定制开发。'
          },
          {
            icon: '📋',
            title: '（六）创新清单产品',
            desc: '创新推出适宜旅游、商务、探亲、劳务和留学的清单产品：在符合救援条件的前提下，提供救援服务无用户年龄限制、无既往病史限制、无风险运动限制、无地理区域限制、无救援次数限制、无救援额度限制的全面保障。'
          }
        ],
        /** 定位及发展方向 */
        directionList: [
          {
            title: '（一）从传统救援向综合救援转型',
            desc: '在传统医疗救援的基础上，大救星平台提供“四救十六助”综合服务，依托覆盖全球的服务商网络及星使网络，真正实现“一键救援”、“有求必救”的便捷、综合服务。'
          },
          {
            title: '（二）从出行场景向生活场景转型',
            desc: '在不断完善升级围绕出行场景的“四救十六助”服务的基础上，大救星平台不断丰富应用场景：围绕社区家庭生活场景推出家庭维保服务，围绕“一老一小一宠物”推出家庭照护服务等，围绕大健康领域推出覆盖国内县级以上城市的健康管理“绿通”服务，围绕特定职业人群、带病体人群提供保险保障、健康监测、健康趋势预报、突发疾病及时预警、私人医生、买药送药、紧急救援、健康管理等全流程、全周期服务。'
          },
          {
            title: '（三）提供全生命周期的健康管理服务',
            desc: '依托“人工智能+大救星健康版App”通过保险保障+智能设备+健康监测预警系统+全球救援网络的大救星智能云平台，为用户提供保险转嫁、健康监测、疾病预警、医疗咨询、医疗救援、医疗费用直付/垫付、院后康复、找药送药、慢病管理等综合服务，实现对用户全生命周期的健康管理。'
          },
          {
            title: '（四）大救星公益',
            desc: '大救星始终坚持不忘善良初心，致力于将爱心传递、薪火相传，积极推动大救星公益板块落地发展。目前已与海南省医疗救助基金会达成合作，共同推动为国内就诊人员提供公益服务及救助服务。'
          }
        ]
    };
  },
  beforeDestroy () {
    // 组件销毁之前,解除所有绑定
    this.$root.bus.$off('about')
    this.$root.bus.$off('back')
  },
  created(){
    let that = this
    if (this.$route.query.activeName) this.activeName = this.$route.query.activeName;
    that.$root.bus.$on('about', value => {
      that.activeName = value;
    })
    that.$root.bus.$on('back', value => {  //back只是一个起到传true和false的作用
      that.isCaseDetail = value;
      that.detail = value;
    })
    // console.log(this.$route.query.activeName)
    // this.activeName = this.$route.query.activeName;
    if (this.$route.query.id) {
      // this.detail = true;
      if(this.$route.query.activeName == 'news'){
        this.detail = true;
        this.isCaseDetail = false;
      }else{
        this.isCaseDetail = true;
        this.detail = false;
      }
      this.id = this.$route.query.id
    }
    this.getNewsList();
    this.geCaseList();
  },
  methods: {
    // getNewsList(){
    //   Axios({
    //     params:{
    //       category:'1',
    //       start: this.start,
    //       count:'10'
    //     },
    //     methods:'post',
    //     baseURL: this.api,
    //     url: '/1.0/portal/portalNews'
    //   }).then(res=>{
    //     this.newsList = res.data.obj;
    //     this.newspageTotal = res.data.total;
    //   }).catch(error=>{
    //     console.log(error)
    //   })
    // },
    getNewsList() {
        Axios({
          params: {
            category: '1', //1 资讯
            start: this.start,
            type:'12',
            count: '10'
          },
          methods: 'post',
          baseURL:this.api,
          url: '/1.0/news/news-list'
        }).then(res => {
          // console.log(res,'首页资讯');
          this.newsList = res.data.obj;
          this.newspageTotal = res.data.total
        }).catch(error => {
          console.log(error)
        })
      },
    geCaseList(){
      Axios({
        params:{
          category:'2',
          start: this.start,
          type:'11',
          count:'10'
        },
        methods:'post',
        baseURL: this.api,
        url: '/1.0/news/news-list'
      }).then(res=>{
        console.log(res,'关于我们服务案例')
        this.caseList = res.data.obj;
        this.pageTotal = res.data.total;
      }).catch(error=>{
        console.log(error)
      })
    },
    handleCurrentChange: function(currentPage,type){
      // this.currentPage = currentPage;
      this.start = (currentPage-1)*this.count;

      this.geCaseList();
      console.log(this.type)  //点击第几页
    },
    handleCurrentChangeNews: function(currentPage){
      this.start = (currentPage-1)*this.count;
      this.getNewsList();
    },
    newsPrev: function(currentPage){
      console.log(currentPage)
    },
    goNewsDetail(item){
      this.id = item.id;
      if(item.attribute == 4) {
        window.open(item.url)
      }else {
        this.detail = true;
      }
     
   
    },
    goCaseDetail(item){
      this.id = item.id;
      if(item.attribute == 4) {
        window.open(item.url)
      }else {
        this.isCaseDetail = true;
      }
   
     
      // 此方法同上作用相同 that.$root.bus.$emit('back', true)
    },
    handleClick(tab, event) {
      if(tab.name=="news"){
        this.detail = false;
        
      }else if(tab.name=="case"){
        this.isCaseDetail = false;
      }
      // console.log(tab, event);
    },
    /**
     * 预览组织架构大图
     */
    previewOrgStructure () {
      this.orgPreviewVisible = true
    },
    // goCaseDetail(id){
    //   this.id = id;
    //   this.isCaseDetail = true;
    // },
    submit(){
      this.$message({
        message: '您已成功提交信息',
        type: 'success'
      });
      // Message.success("您已成功提交信息");
    },
    format(timestamp){
      var date = new Date(timestamp);
      let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    }
  }
}
</script>
<style lang="scss">
#app{
  .el-pagination{
    padding-left: 18vw;
  }
}
.banner{
  width: 100%;
  img{
    width: 100%;
  }
}
  .aboutus{
    background: #fff;
    padding-top: 3.645833vw;
    padding-bottom: 2.604166vw;
    .el-tabs{
      padding: 0 17vw;
      /*width: 1191px;
      margin: 0 auto;*/
      .el-tabs__nav-wrap{
        width: 11.71875vw;
        background: #B1E6FF;
        border: 1px solid #99DDFD;
        padding-top: .520833vw;
      }
      .el-tabs__item{
        text-align: center!important;
        line-height: 3.125vw;
        background: #fff;
        color: #333;
        font-size:1.0412vw;
        height: 3.125vw;
      }
      .el-tabs__item.is-active{
        background: #00ABFA;
        color: #fff;
      }
      .el-tabs__item{
        padding: 0;
      }
      h2{
          font-weight: normal;
          font-size: 1.5625vw;
          margin-bottom: 1.5625vw;
        }
      /* ========== 关于我们 PC 版（参考 H5） ========== */
      .about-us-pc {
        .au-banner {
          width: 100%;
          margin-bottom: 1.25vw;
          border-radius: 0.625vw;
          overflow: hidden;
          box-shadow: 0 0.104vw 0.625vw rgba(0, 0, 0, 0.08);
          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }

        .au-section {
          background: #fff;
          border-radius: 0.625vw;
          margin-bottom: 1.25vw;
          overflow: hidden;
          box-shadow: 0 0.104vw 0.625vw rgba(0, 0, 0, 0.04);
          border: 1px solid #eef2f6;
        }

        .au-section__title {
          background: linear-gradient(135deg, #00abfa 0%, #0088cc 100%);
          padding: 0.833vw 1.25vw;
          text-align: center;
          h2 {
            color: #fff;
            font-size: 1.146vw;
            font-weight: 600;
            margin: 0;
            line-height: 1.4;
          }
        }

        .au-section__body {
          padding: 1.458vw 1.667vw;
        }

        .au-text {
          font-size: 0.938vw;
          line-height: 1.9;
          color: #555;
          margin-bottom: 1.042vw;
          text-align: justify;
          &:last-child {
            margin-bottom: 0;
          }
        }

        .au-text--mt {
          margin-top: 1.25vw;
        }

        .au-honor-list {
          display: flex;
          gap: 1.042vw;
          margin-top: 0.833vw;
        }

        .au-honor-item {
          flex: 1;
          padding: 1.042vw 1.146vw;
          background: linear-gradient(135deg, #f5f9fc 0%, #e8f4fb 100%);
          border-radius: 0.417vw;
          border-top: 0.208vw solid #00abfa;
          font-size: 0.885vw;
          color: #333;
          line-height: 1.6;
          text-align: center;
        }

        .au-org-img {
          position: relative;
          margin-top: 1.25vw;
          border-radius: 0.417vw;
          overflow: hidden;
          cursor: pointer;
          border: 1px solid #eef2f6;
          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }

        .au-org-tip {
          position: absolute;
          right: 0.625vw;
          bottom: 0.625vw;
          padding: 0.26vw 0.729vw;
          background: rgba(0, 0, 0, 0.55);
          color: #fff;
          font-size: 0.729vw;
          border-radius: 0.833vw;
          line-height: 1.4;
          pointer-events: none;
        }

        .au-stats-panel {
          background-image: url('./img/2.jpg');
          background-size: cover;
          background-position: center;
          border-radius: 0.625vw;
          padding: 1.458vw;
          margin-bottom: 0.521vw;
        }

        .au-stats-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.042vw;
        }

        .au-stat-card {
          background: rgba(0, 0, 0, 0.42);
          border-radius: 0.625vw;
          padding: 1.458vw 0.833vw;
          text-align: center;
          color: #fff;
          transition: transform 0.25s ease;
          &:hover {
            transform: translateY(-0.208vw);
          }
        }

        .au-stat-number {
          font-size: 1.667vw;
          font-weight: 700;
          margin-bottom: 0.417vw;
          line-height: 1.2;
          color: #fff;
        }

        .au-stat-label {
          font-size: 0.833vw;
          opacity: 0.95;
          line-height: 1.4;
        }

        .au-service-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.042vw;
        }

        .au-service-item {
          padding: 1.146vw 1.25vw;
          background: #f8fafc;
          border-radius: 0.521vw;
          border-left: 0.208vw solid #00abfa;
          transition: box-shadow 0.25s ease;
          &:hover {
            box-shadow: 0 0.208vw 0.833vw rgba(0, 171, 250, 0.12);
          }
        }

        .au-service-title {
          font-size: 1.042vw;
          font-weight: 600;
          color: #333;
          margin-bottom: 0.625vw;
        }

        .au-service-desc {
          font-size: 0.885vw;
          color: #666;
          line-height: 1.8;
          text-align: justify;
        }

        .au-advantage-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.042vw;
          margin-top: 0.833vw;
        }

        .au-advantage-item {
          display: flex;
          align-items: flex-start;
          gap: 0.833vw;
          padding: 1.146vw;
          background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
          border-radius: 0.521vw;
          border: 1px solid #e9ecef;
          transition: all 0.25s ease;
          &:hover {
            box-shadow: 0 0.208vw 0.833vw rgba(0, 171, 250, 0.15);
            transform: translateY(-0.104vw);
          }
        }

        .au-advantage-icon {
          font-size: 1.875vw;
          flex-shrink: 0;
          line-height: 1;
        }

        .au-advantage-content {
          flex: 1;
          min-width: 0;
        }

        .au-advantage-title {
          font-size: 1.042vw;
          font-weight: 600;
          color: #333;
          margin-bottom: 0.417vw;
        }

        .au-advantage-desc {
          font-size: 0.885vw;
          color: #666;
          line-height: 1.7;
          text-align: justify;
        }

        .au-contact-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.042vw;
        }

        .au-contact-card {
          display: flex;
          align-items: flex-start;
          gap: 0.833vw;
          padding: 1.25vw;
          background: #fff;
          border-radius: 0.625vw;
          border: 1px solid #e9ecef;
          box-shadow: 0 0.104vw 0.417vw rgba(0, 0, 0, 0.04);
          transition: all 0.25s ease;
          &:hover {
            box-shadow: 0 0.208vw 0.833vw rgba(0, 171, 250, 0.15);
            transform: translateY(-0.104vw);
          }
        }

        .au-contact-icon {
          flex-shrink: 0;
          width: 2.604vw;
          height: 2.604vw;
          border-radius: 0.625vw;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #00abfa 0%, #0088cc 100%);
          i {
            font-size: 1.25vw;
            color: #fff;
          }
        }

        .au-contact-icon--emergency {
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
        }

        .au-contact-icon--biz {
          background: linear-gradient(135deg, #4ecdc4 0%, #00abfa 100%);
        }

        .au-contact-info {
          flex: 1;
          min-width: 0;
        }

        .au-contact-label {
          font-size: 0.938vw;
          font-weight: 600;
          color: #333;
          margin-bottom: 0.625vw;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 0.521vw;
        }

        .au-contact-tag {
          display: inline-block;
          padding: 0.156vw 0.521vw;
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
          color: #fff;
          font-size: 0.729vw;
          border-radius: 0.625vw;
          font-weight: 500;
        }

        .au-contact-link {
          font-size: 0.938vw;
          color: #00abfa;
          text-decoration: none;
          font-weight: 500;
          word-break: break-all;
          &:hover {
            color: #0088cc;
            text-decoration: underline;
          }
        }

        .au-contact-phones {
          display: flex;
          flex-direction: column;
          gap: 0.417vw;
          margin-bottom: 0.521vw;
        }

        .au-contact-phone {
          display: inline-flex;
          align-items: center;
          font-size: 0.938vw;
          color: #333;
          text-decoration: none;
          font-weight: 500;
          padding: 0.417vw 0.625vw;
          background: #f8f9fa;
          border-radius: 0.417vw;
          transition: all 0.25s ease;
          &:hover {
            background: #e9ecef;
            color: #00abfa;
          }
        }

        .au-contact-phone--emergency {
          font-size: 1.146vw;
          font-weight: 600;
          color: #ff6b6b;
          background: #fff5f5;
          &:hover {
            background: #ffe0e0;
            color: #ee5a6f;
          }
        }

        .au-contact-time {
          display: flex;
          align-items: center;
          gap: 0.313vw;
          font-size: 0.781vw;
          color: #999;
          margin-top: 0.417vw;
          i {
            color: #00abfa;
          }
        }
      }
      .aboutbox{
        p{
          color: #333;
          font-size: 1.0412vw;
          margin-bottom: 1.5625vw;
          line-height: 1.5625vw;
          span{
            display: block;
          }
        }
        h4{
          font-weight: normal;
          margin-bottom: 20px;
          font-size: 22px;
          border-bottom: 4px solid #00ABFA;
          width: fit-content;
        }
      }
      .newsbox{
        dl{
          overflow: hidden;
          display: flex;
          margin-bottom: 2.604166vw;
          dt{
            width: 11.25vw;
            height: 9.375vw;
            flex-shrink: 0;
            margin-right: 1.25vw;
            img{
              width: 100%;
              height: 100%;
            }
          }
          dd{
            width: 37.8vw;
            flex-shrink: 0;
            h6{
              padding: .8vw 0;
              span{
                font-size: 1.0412vw;
                color: #333;
                font-weight: normal;
                display: inline-block;
                width: 29vw;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
              
              i{
                float: right;
                color: #888;
                padding-top: .520833vw;
                font-weight: normal;
                font-size: .8333vw;
                line-height: 0.41666vw;
                font-style: normal;;
              }
            }
            p{
              font-size: .8854vw;
              color: #666;
              line-height: 1.875vw;
              // height: 4.2708vw;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              // position: relative;
              // &:after{
              //   content: '...';
              //   background: #fff;
              //   position: absolute;
              //   right: 0;
              //   bottom: 0;
              //   padding-left: .520833vw;
              // }
            }
            
          }
        }
      }
      .jylmbox{
        h4{
          color: #666;
          font-size: 1.145833vw;
          font-weight: normal;
          line-height: 2.083333vw;
        }
        h3{
          color: #333;
          font-size: 1.3541666vw;
          padding: 2.604166vw 0;
          font-weight: normal;
        }
        ol{
          li{
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-size: 1.145833vw;
            color: #333;
            line-height: 3.125vw;
            img{
              margin-right: .8vw;
            }
          }
        }
        button{
          width: 18.75vw;
          height: 3.4375vw;
          border: 0;
          border-radius: 4px;
          background: #00abfa;
          color: #fff;
          margin-top: 2.8645833vw;
          font-size: 1.25vw;
          margin-left: 5.20833vw;
        }
      }
      .xingshibox{
        h4{
          color: #666666;
          font-size: 1.0412vw;
          font-family:Microsoft YaHei;
          font-weight: normal;
          margin-bottom: 1.5625vw;
          line-height: 1.8vw;
        }
        p{
          font-size:1.0412vw;
          color: #666;
          font-weight: bold;
          margin-top: 1.302083vw;
          img{
            margin-right: .520833vw;
          }
        }
        p{

        }
      }
    }
    .el-tabs--left .el-tabs__nav-wrap.is-left::after, .el-tabs--left .el-tabs__nav-wrap.is-right::after, .el-tabs--right .el-tabs__nav-wrap.is-left::after, .el-tabs--right .el-tabs__nav-wrap.is-right::after{
      width: 0;
    }
    .el-tabs--left .el-tabs__active-bar.is-left, .el-tabs--left .el-tabs__active-bar.is-right, .el-tabs--right .el-tabs__active-bar.is-left, .el-tabs--right .el-tabs__active-bar.is-right{
      width: 0;
    }
    .el-tabs--left .el-tabs__header.is-left{
      margin-right: 3.0208333vw;
    }
  }
.modal {
  // position: absolute;
  // top: 50%;
  // margin-top: -21.25vw;
  // left: 50%;
  // margin-left: -28.125vw;
  // background: #fff;
  // width: 56.25vw;
  // height: 42.5vw;
  // z-index: 998;
  // border-radius: 0.3125vw;
  // border: 0.0625vw solid #d9ddde;
  h2 {
    width: 100%;
    text-align: center;
    margin-top: 0.625vw;
    line-height: 3.125vw;
    font-size: 1.25vw;
    color: #333;
  }
  form {
    width: 100%;
    padding: 1vw 5vw 2vw;
    box-sizing: border-box;
    label {
      display: block;
      width: 100%;
      height: 2.8125vw;
      margin-top: 1.875vw;
      &:first-child {
        margin-top: 0;
      }
      span {
        float: left;
        width: 11.25vw;
        small {
          display: inline-block;
          width: 100%;
          &:first-child {
            font-size: 1vw;
            color: #303030;
          }
          &:last-child {
            font-size: 0.875vw;
            color: #777;
          }
        }
      }
      input {
        float: left;
        height: 2.8125vw;
        width: 25.125vw;
        border: 0;
        border-radius: 0.3125vw;
        border: 0.0625vw solid #ccc;
        padding-left: 0.9vw;
      }
    }
  }
}
.modal > p {
  width: 100%;
  text-align: center;
}
.modal > p button {
  width: 17.5vw;
  height: 3.125vw;
  border: 0;
  border-radius: 0.25vw;
  background: #00abfa;
  font-size: 1.3125vw;
  color: #fff;
}

/* 组织架构预览弹窗 */
.au-org-dialog {
  .au-org-dialog__img {
    width: 100%;
    height: auto;
    display: block;
  }
  .el-dialog__body {
    padding: 1vw 1.5vw 1.5vw;
    max-height: 80vh;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutus/aboutus.vue